import React, { useState } from 'react';
import { Modal, Form, Input, InputNumber, message } from 'antd';
import { api } from '../../services/api';

const AddCreditModal = ({ open, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const response = await api.addCredits({
        emailAddress: values.emailAddress.trim(),
        amount: Number(values.amount),
      });

      if (response.data?.success) {
        message.success(response.data.message || 'Credits added successfully!');
        form.resetFields();
        if (onSuccess) onSuccess();
        onCancel();
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.errors?.[0]?.error ||
        error.response?.data?.errors?.[0]?.message ||
        (error.response?.data?.message && error.response?.data?.message !== 'RESOURCE_NOT_FOUND'
          ? error.response?.data?.message
          : null) ||
        'Failed to add credits';
      message.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Add User Credits"
      open={open}
      onOk={handleSubmit}
      onCancel={handleCancel}
      confirmLoading={loading}
      okText="Add Credits"
      cancelText="Cancel"
      width={500}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
      >
        <Form.Item
          name="emailAddress"
          label="User Email Address"
          rules={[
            { required: true, message: 'Please enter user email address' },
            { type: 'email', message: 'Please enter a valid email address' },
          ]}
        >
          <Input placeholder="e.g. user@example.com" />
        </Form.Item>

        <Form.Item
          name="amount"
          label="Credit Amount"
          rules={[
            { required: true, message: 'Please enter credit amount' },
            { type: 'number', min: 1, message: 'Amount must be at least 1' },
          ]}
        >
          <InputNumber
            min={1}
            precision={0}
            style={{ width: '100%' }}
            placeholder="e.g. 50"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddCreditModal;
